import React from "react";
import { Box, TextField, IconButton } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";

const ChatInput = ({ messageText, setMessageText, onSend }) => (
  <Box sx={{ p: 1.5, display: "flex", gap: 1, bgcolor: "#f0f0f0" }}>
    <TextField
      fullWidth
      size="small"
      placeholder="Type a message"
      value={messageText}
      onChange={(e) => setMessageText(e.target.value)}
      onKeyDown={(e) => e.key === "Enter" && onSend()}
    />
    <IconButton color="primary" onClick={onSend}>
      <SendIcon />
    </IconButton>
  </Box>
);

export default ChatInput;
